export enum CondicionVenta{
    indeterminado,
    contado,
    cuentaCorriente
}